import React, { Component } from 'react';
import ajax from 'superagent';

import Slider from './Slider';
import FeaturesInline from './FeaturesInline';
import ServicesSection from './ServicesSectionFR';
import Features from './Features';
import Team from './TeamSectionFR';
import LatestNews from './LatestNewsFR';
import Clients from './Clients';

import '../css/style.css';
import '../css/default.css';
import '../css/responsive.css';
import '../App.css';

import data from '../data/dataFR.json';

class HomeFR extends Component {
  state = {
    slides: data.slides,
    services: data.services,
    features: data.about.plan,
    // teamTitle: data.team_title,
    // team: data.temp,
    clients: data.clients,
    featuresInline: data.about.featuresInline,
    latestArticles: [],
  };

  componentWillMount() {
    this.getData();
  }

  getData() {
    ajax.get('https://www.digitalcongo.net/app/api/v3/category/home').end((error, response) => {
      if (!error && response) {
        this.setState({ latestArticles: response.body.latestArticles });
      } else {
        console.log('There was an error fetching data from DC6 API', error);
      }
    });
  }

  render() {
    return (
      <div>
        <Slider slides={this.state.slides} />
        <FeaturesInline featuresInline={this.state.featuresInline} />
        <ServicesSection services={this.state.services} />
        <Features features={this.state.features} />
        <LatestNews articles={this.state.latestArticles} />
        {/* <Team title={this.state.teamTitle} team={this.state.team} /> */}
        <Clients clients={this.state.clients} />
      </div>
    );
  }
}

export default HomeFR;



// WEBPACK FOOTER //
// ./src/components/HomeFR.js